module.exports = __webpack_public_path__ + "static/media/YF17_1.617b1c69.jpg";